import { enumValues, nullable, object, timestamp } from "../../../types/_types";

import { UserRef } from "../../users/types/User";

import approvalStatuses from "../constants/approvalStatuses";

export const approval = () =>
	object({
		status: enumValues(approvalStatuses),
		timestamp: nullable(timestamp()),
		user: nullable(UserRef),
	}).default({
		status: approvalStatuses.PENDING,
		timestamp: null,
		user: null,
	});
